import React, { Component } from 'react';
import {
  TextField, Tooltip, IconButton
} from "@material-ui/core";
import "./TicketSettings.css"
import {
  TICKET_SETTINGS_TOOLBAR_TITLE,
  OTHER_COSTS_INFO_PART1,
  RETURN_LABEL_COST_INFO,
  PRICE_INFO,
  SHIPPING_COST_INFO,
} from "./constants.js"
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";

import { userInfoSelector } from "../../redux/selectors/auth"
import withShipment from "../../withShipment";
import {
  tableSettingSelector
} from '../../redux/selectors/account';
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { FormControl, Radio, RadioGroup} from "@mui/material";
import TopToolbar from "../global/subcomponents/topToolbar/TopToolbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { DIFFERENCE_REDIRECT_LABEL_INFO } from '../returns/constants';

class TicketSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnOtherCostType: 'dollar',
      returnOtherCostDefaultValue: '0.00',
      returnPercentageCostText: '',
      returnDollarCostText: '',
      returnDeductShippingCost: false,
      returnDeductReturnLabelCost: false,

      otherCostType: 'dollar',
      otherCostDefaultValue: '0.00',
      percentageCostText: '',
      dollarCostText: '',
      deductShippingCost: false,
      deductDifferenceForRedirectLabels: false,
    };
  }

  handleReturnChange = (event, name) => {
    this.setState({ [name]: event.target.checked },()=>{
      this.updateReturnHandler();
    });
  };


  updateReturnState = () => {
    this.setState({
      returnOtherCostType: this.props.ticketSettings?.returnSetting?.otherCostType,
      returnOtherCostDefaultValue: this.props.ticketSettings?.returnSetting?.otherCostDefaultValue,
      returnDeductShippingCost: this.props.ticketSettings?.returnSetting?.deductShippingCost,
      returnDeductReturnLabelCost: this.props.ticketSettings?.returnSetting?.deductReturnLabelCost,
    });
  }

  componentDidMount = () => {
    this.props.getTicketSettings()
    this.updateReturnState()
    this.updateState()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if(prevProps.ticketSettings !== this.props.ticketSettings) {
      this.updateState()
      this.updateReturnState()
    }

  }

  updateReturnHandler = () => {
    let inputObject = {};
    inputObject["deductShippingCost"] = this.state.returnDeductShippingCost;
    inputObject["deductReturnLabelCost"] = this.state.returnDeductReturnLabelCost;
    inputObject["otherCostType"] = this.state.returnOtherCostType;
    inputObject["otherCostDefaultValue"] = this.state.returnOtherCostDefaultValue;

    this.props.updateticketSettings({
      companyId: this.props.user.company,
      returnSetting: inputObject,
    });
  }


  handleReturnOtherCostChange = async (text) => {
    await this.setState({
      returnOtherCostDefaultValue: text,
    });
    this.updateReturnHandler();
  }


  handleReturnPageToggle = async (value) => {
    await this.setState({
      returnOtherCostType: value,
    })

    this.updateReturnHandler();
  }


  handleChange = (event, name) => {
    this.setState({ [name]: event.target.checked },()=>{
      this.updateHandler();
    });
  };

  updateState = () => {
    this.setState({
      otherCostType: this.props.ticketSettings?.redirectSetting?.otherCostType,
      otherCostDefaultValue: this.props.ticketSettings?.redirectSetting?.otherCostDefaultValue,
      deductShippingCost: this.props.ticketSettings?.redirectSetting?.deductShippingCost,
      deductDifferenceForRedirectLabels: this.props.ticketSettings?.redirectSetting?.deductDifferenceForRedirectLabels,
    });
  }

  updateHandler = () => {
    let inputObject = {};
    inputObject["deductShippingCost"] = this.state.deductShippingCost;
    inputObject["deductDifferenceForRedirectLabels"] = this.state.deductDifferenceForRedirectLabels;
    inputObject["otherCostType"] = this.state.otherCostType;
    inputObject["otherCostDefaultValue"] = this.state.otherCostDefaultValue;

    this.props.updateticketSettings({
      companyId: this.props.user.company,
      redirectSetting: inputObject,
    });
  }


  handleOtherCostChange = async (text) => {
    await this.setState({
      otherCostDefaultValue: text,
    });
    this.updateHandler();
  }


  handlePageToggle = async (value) => {
    await this.setState({
      otherCostType: value,
    })
    this.updateHandler();
  }


  render() {
    return (
      <>
        <TopToolbar
          pageName={TICKET_SETTINGS_TOOLBAR_TITLE}
          menuItems={[
            {
              title: 'Back',
              icon: <KeyboardBackspaceIcon />,
              onClick: () => this.props.openSettings(false),
            },
          ]}
        />
        <div className="page">
          <div>
            <div className="profitStyle">
              Return cost calculation
              <br />
            </div>
            <div className="other-margin" style={{ marginLeft: '34px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  label="Price"
                  InputProps={{
                    disabled: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>{PRICE_INFO}</React.Fragment>
                          }
                        >
                          <IconButton aria-label="info">
                            <InfoOutlinedIcon
                              variant="outlined"
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  InputLabelProps={{ className: 'price-label' }}
                  style={{
                    marginBottom: '5px',
                    maxWidth: '175px',
                    minWidth: '175px',
                  }}
                />
              </div>
            </div>
            <div className="signs">-</div>
            <div className="other-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.23)', // Matches TextField's default border
                    borderRadius: '4px', // Rounded corners like TextField
                    paddingTop: '5px', // Adjust padding to match the TextField
                    paddingBottom: '0px',
                    maxWidth: '200px',
                    minWidth: '200px',
                  }}
                >
                  <FormControlLabel
                    style={{ marginLeft: '4px' }}
                    control={
                      <Checkbox
                        checked={this.state.returnDeductShippingCost}
                        onChange={(event) =>
                          this.handleReturnChange(event, 'returnDeductShippingCost')
                        }
                        color="primary"
                      />
                    }
                    label={
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        Shipping Cost
                        <Tooltip
                          style={{ marginLeft: '5px' }}
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>
                              {SHIPPING_COST_INFO}
                            </React.Fragment>
                          }
                        >
                          <IconButton aria-label="info" size="small">
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="signs" style={{ marginLeft: '24px' }}>
              -
            </div>
            <div className="other-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.23)', // Matches TextField's default border
                    borderRadius: '4px', // Rounded corners like TextField
                    paddingTop: '5px', // Adjust padding to match the TextField
                    paddingBottom: '0px',
                    maxWidth: '300px',
                    minWidth: '300px',
                  }}
                >
                  <FormControlLabel
                    style={{ marginLeft: '4px' }}
                    control={
                      <Checkbox
                        checked={this.state.returnDeductReturnLabelCost}
                        onChange={(event) =>
                          this.handleReturnChange(event, 'returnDeductReturnLabelCost')
                        }
                        color="primary"
                      />
                    }
                    label={
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        Return Label Cost
                        <Tooltip
                          style={{ marginLeft: '5px' }}
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>
                              {RETURN_LABEL_COST_INFO}
                            </React.Fragment>
                          }
                        >
                          <IconButton aria-label="info" size="small">
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="signs" style={{ marginLeft: '124px' }}>
              -
            </div>
            <div className="tick-box">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={this.state.returnOtherCostType}
                  name="radio-buttons-group"
                  onChange={(event) => {
                    this.handleReturnPageToggle(event.target.value);
                  }}
                >
                  <FormControlLabel
                    value="percentage"
                    control={<Radio />}
                    label="%"
                    style={{ maxHeight: '20px', marginRight: '0px' }}
                  />
                  <FormControlLabel
                    value="dollar"
                    control={<Radio />}
                    label="$"
                    style={{ maxHeight: '23px', marginRight: '0px' }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="other-cost-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  style={{
                    marginBottom: '5px',
                    maxWidth: '150px',
                    minWidth: '150px',
                  }}
                  variant="outlined"
                  label="Other Costs"
                  error={
                    isNaN(parseFloat(this.state.returnOtherCostDefaultValue)) ||
                    !isFinite(this.state.returnOtherCostDefaultValue)
                  }
                  value={this.state.returnOtherCostDefaultValue}
                  InputProps={
                    this.state.returnOtherCostType === "dollar"
                      ? {
                        startAdornment: (
                          <InputAdornment position="start">
                            $
                          </InputAdornment>
                        ),
                      }
                      : {
                        endAdornment: (
                          <InputAdornment position="end">
                            %
                          </InputAdornment>
                        ),
                      }
                  }
                  onChange={(e) =>
                    this.handleReturnOtherCostChange(e.target.value)
                  }
                  onBlur={() => {
                    const value = this.state.returnOtherCostDefaultValue;
                    const number = parseFloat(value);

                    if (!isNaN(number)) {
                      // Format to 2 decimal places
                      this.handleReturnOtherCostChange(number.toFixed(2));
                    } else {
                      this.handleReturnOtherCostChange('0.00');
                    }
                  }}
                />
                <Tooltip
                  enterTouchDelay={0}
                  leaveTouchDelay={30000}
                  enterDelay={400}
                  // leaveDelay={1000000} // for testing purposes
                  title={
                    <React.Fragment>
                      <p>{OTHER_COSTS_INFO_PART1}</p>
                    </React.Fragment>
                  }
                >
                  <IconButton aria-label="info">
                    <InfoOutlinedIcon variant="outlined" fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>

          <div>
            <div className="profitStyle">
              Redirect cost calculation
              <br />
            </div>
            <div className="other-margin" style={{ marginLeft: '34px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  label="Price"
                  InputProps={{
                    disabled: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>{PRICE_INFO}</React.Fragment>
                          }
                        >
                          <IconButton aria-label="info">
                            <InfoOutlinedIcon
                              variant="outlined"
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  InputLabelProps={{ className: 'price-label' }}
                  style={{
                    marginBottom: '5px',
                    maxWidth: '175px',
                    minWidth: '175px',
                  }}
                />
              </div>
            </div>
            <div className="signs">-</div>
            <div className="other-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.23)', // Matches TextField's default border
                    borderRadius: '4px', // Rounded corners like TextField
                    paddingTop: '5px', // Adjust padding to match the TextField
                    paddingBottom: '0px',
                    maxWidth: '200px',
                    minWidth: '200px',
                  }}
                >
                  <FormControlLabel
                    style={{ marginLeft: '4px' }}
                    control={
                      <Checkbox
                        checked={this.state.deductShippingCost}
                        onChange={(event) =>
                          this.handleChange(event, 'deductShippingCost')
                        }
                        color="primary"
                      />
                    }
                    label={
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        Shipping Cost
                        <Tooltip
                          style={{ marginLeft: '5px' }}
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>
                              {SHIPPING_COST_INFO}
                            </React.Fragment>
                          }
                        >
                          <IconButton aria-label="info" size="small">
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="signs" style={{ marginLeft: '24px' }}>
              -
            </div>
            <div className="other-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.23)', // Matches TextField's default border
                    borderRadius: '4px', // Rounded corners like TextField
                    paddingTop: '5px', // Adjust padding to match the TextField
                    paddingBottom: '0px',
                    maxWidth: '300px',
                    minWidth: '300px',
                  }}
                >
                  <FormControlLabel
                    style={{ marginLeft: '4px' }}
                    control={
                      <Checkbox
                        checked={this.state.deductDifferenceForRedirectLabels}
                        onChange={(event) =>
                          this.handleChange(event, 'deductDifferenceForRedirectLabels')
                        }
                        color="primary"
                      />
                    }
                    label={
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        Difference of Redirect Label
                        <Tooltip
                          style={{ marginLeft: '5px' }}
                          enterTouchDelay={0}
                          leaveTouchDelay={30000}
                          enterDelay={400}
                          title={
                            <React.Fragment>
                              {DIFFERENCE_REDIRECT_LABEL_INFO}
                            </React.Fragment>
                          }
                        >
                          <IconButton aria-label="info" size="small">
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="signs" style={{ marginLeft: '124px' }}>
              -
            </div>
            <div className="tick-box">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={this.state.otherCostType}
                  name="radio-buttons-group"
                  onChange={(event) => {
                    this.handlePageToggle(event.target.value);
                  }}
                >
                  <FormControlLabel
                    value="percentage"
                    control={<Radio />}
                    label="%"
                    style={{ maxHeight: '20px', marginRight: '0px' }}
                  />
                  <FormControlLabel
                    value="dollar"
                    control={<Radio />}
                    label="$"
                    style={{ maxHeight: '23px', marginRight: '0px' }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="other-cost-margin">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  style={{
                    marginBottom: '5px',
                    maxWidth: '150px',
                    minWidth: '150px',
                  }}
                  variant="outlined"
                  label="Other Costs"
                  error={
                    isNaN(parseFloat(this.state.otherCostDefaultValue)) ||
                    !isFinite(this.state.otherCostDefaultValue)
                  }
                  value={this.state.otherCostDefaultValue}
                  InputProps={
                    this.state.otherCostType === "dollar"
                      ? {
                        startAdornment: (
                          <InputAdornment position="start">
                            $
                          </InputAdornment>
                        ),
                      }
                      : {
                        endAdornment: (
                          <InputAdornment position="end">
                            %
                          </InputAdornment>
                        ),
                      }
                  }
                  onChange={(e) =>
                    this.handleOtherCostChange(e.target.value)
                  }
                  onBlur={() => {
                    const value = this.state.otherCostDefaultValue;
                    const number = parseFloat(value);

                    if (!isNaN(number)) {
                      // Format to 2 decimal places
                      this.handleOtherCostChange(number.toFixed(2));
                    } else {
                      this.handleOtherCostChange('0.00');
                    }
                  }}
                />
                <Tooltip
                  enterTouchDelay={0}
                  leaveTouchDelay={30000}
                  enterDelay={400}
                  // leaveDelay={1000000} // for testing purposes
                  title={
                    <React.Fragment>
                      <p>{OTHER_COSTS_INFO_PART1}</p>
                    </React.Fragment>
                  }
                >
                  <IconButton aria-label="info">
                    <InfoOutlinedIcon variant="outlined" fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

}

const mapStateToProps = (state) => ({
  user: userInfoSelector(state),
  tableSetting: tableSettingSelector(state),
})

const actionCreators = {
}

TicketSettings.defaultProps = {
  tableSetting: {}
}

export default withShipment({
  mapStateToProps,
  actionCreators
}, TicketSettings);